import { Card, CardBody, CardHeader } from "reactstrap";
import { HelpCollapseButton } from "./HelpCollapseButton";
import { HelpCollapseArea } from "./HelpCollapseArea";
import { PropsWithChildren, ReactNode, useState } from "react";

interface Props {
  title: string;
  helpCollapsedArea?: ReactNode | undefined;
  dataCy?: string;
}

export function ItemCard({
  title,
  helpCollapsedArea,
  children,
  dataCy,
}: PropsWithChildren<Props>) {
  const [isOpen, setIsOpen]: [
    boolean,
    (value: ((prevState: boolean) => boolean) | boolean) => void,
  ] = useState(false);

  return (
    <Card data-cy={dataCy}>
      <CardHeader className="d-flex align-items-center">
        <div className="flex-grow-1">{title}</div>
        <HelpCollapseButton
          setIsOpen={setIsOpen}
          disabled={!helpCollapsedArea}
        />
      </CardHeader>
      <CardBody>
        <HelpCollapseArea isOpen={isOpen}>{helpCollapsedArea}</HelpCollapseArea>
        {children}
      </CardBody>
    </Card>
  );
}
